import { render, staticRenderFns } from "./wasteWater.vue?vue&type=template&id=78500cb4&scoped=true&"
import script from "./wasteWater.vue?vue&type=script&lang=js&"
export * from "./wasteWater.vue?vue&type=script&lang=js&"
import style0 from "./wasteWater.vue?vue&type=style&index=0&id=78500cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78500cb4",
  null
  
)

export default component.exports